<template>
<div style="position:relative;">
    <mt-swipe :auto="auto" class="banner" v-if="list" ref="swipeWrapper" :style="{height:height+'px'}">
        <mt-swipe-item v-for="item in list" v-bind:key="item.id" v-if="item.mobileImageUrl">
            <a :href="item.link" v-if="item.link">
                <img v-lazy="item.mobileImageUrl" :style="{height:height+'px'}" />
            </a>
            <img v-lazy="item.mobileImageUrl" v-else :style="{height:height+'px'}" />
        </mt-swipe-item>
    </mt-swipe>
    <div class="button-wrapper" v-if="showBtn">
        <a class="prev-button flex-item" @click="prev"><img src="@/../static/icon_previous.png"/></a>
        <a class="next-button flex-item" @click="next"><img src="@/../static/icon_next.png"/></a>
    </div>
</div>
</template>

<script>

import { Swipe, SwipeItem } from 'mint-ui'

export default {
    name: 'banner',
    components: {
        "mt-swipe": Swipe, 
        "mt-swipe-item": SwipeItem
    },
    data(){
        return {
        }
    },
    methods:{
            prev: function () {
                this.$refs.swipeWrapper.clearTimer()
                 let index = this.$refs.swipeWrapper.index;
                 this.$refs.swipeWrapper.prev();
                 index++;
                 this.$refs.swipeWrapper._data.index = index;

                 this.$refs.swipeWrapper.initTimer();
            },
            next: function () {
                 this.$refs.swipeWrapper.clearTimer()
                 let index = this.$refs.swipeWrapper.index;
                 this.$refs.swipeWrapper.next();
                 index++;
                 this.$refs.swipeWrapper._data.index = index;

                 this.$refs.swipeWrapper.initTimer();
            }
    },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        auto: {
            type: Number,
            default: 5000
        },
        height:{
            type:Number,
            default: 840
        },
        showBtn:{
            type: Boolean,
            default:true
        },
        showCover:{
            type: Boolean,
            default:false
        }
    },
}
</script>

<style scoped>
.pic-wrapper{
    width: 100%;
    margin: 0 auto;
    position: absolute;
    width: 100%;
}
.pic-left,.pic-right{
    position: absolute;
    height: 100%;
}
.pic-left{
    left: 0;
}
.pic-right{
    right: 0;
}
.pic-left img{
    height: 100%;
}
.pic-right img{
    height: 100%;
}
.banner{
    width: 100%;
    margin: 0 auto;
}
.banner div{
    height: auto;
    width: 100%;
}
.banner img{
    width: 100%;
}
.button-wrapper{
    position: absolute;
    top: 45%;
    width: 100%;
}
.prev-button{
    float:left;
    margin-left: 12px;
}
.next-button{
    float:right;
    margin-right: 12px;
}
.flex-item{
    cursor: pointer;
}
.flex-item img{
    width: 20px;
    height:20px;
}
.flex-item img:hover{
    filter:contrast(50%);
}
</style>



// WEBPACK FOOTER //
// src/components/MobileBanner.vue